import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Popover} from "react-bootstrap";
import './DriverPopover.css';
import MaskedInput from "../../../../controls/MaskedInput";

class DriverPopover extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
        onSave: PropTypes.func,
        close: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        driver: this.props.data.driver || '',
        driverPhoneNumber: this.props.data.driverPhoneNumber || '',
        vehicle: this.props.data.vehicle || ''
    };

    render() {
        const {onSave, close, data, ...props} = this.props;
        return (
            <Popover id="supplier-rate-popover" {...props}>
                <div className="m-b-1">
                    <input type="text" className="form-control" placeholder="Водитель"
                           value={this.state.driver}
                           onChange={event => this.setState({driver: event.target.value})}/>
                </div>
                <div className="m-b-1">
                    <MaskedInput type="text" className="form-control" placeholder="Телефон водителя"
                                 mask="+9 (999) 999-9999"
                                 value={this.state.driverPhoneNumber}
                                 onChange={event => this.setState({driverPhoneNumber: event.target.value})}/>
                </div>
                <div className="m-b-2">
                    <input type="text" className="form-control" placeholder="Транспортное средство"
                           value={this.state.vehicle}
                           onChange={event => this.setState({vehicle: event.target.value})}/>
                </div>
                <div className="clearfix">
                    <button type="button" className="btn btn-default btn-3d"
                            onClick={() => close()}>
                        Отмена
                    </button>
                    <button type="button" className="btn btn-success btn-3d pull-right"
                            onClick={() => this.saveDriver()}>
                        Сохранить
                    </button>
                </div>
            </Popover>
        );
    }

    saveDriver() {
        const {onSave} = this.props;

        if (onSave) onSave({
            driver: this.state.driver,
            driverPhoneNumber: this.state.driverPhoneNumber,
            vehicle: this.state.vehicle
        });
    }
}

export default DriverPopover;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/TenderRequests/popovers/DriverPopover.js